import { AxiosResponse } from "axios";
import { apiNode } from "./api";
import { DefaultGetParamsProps } from "./types/interfaces";
import {
	GetComputedObjectPermissionsDataResponse,
	GetObjectPermissionsDataResponse,
	GetUserPermissionLevelDataResponse
} from "./types/permission.interfaces";

const URL = "2/permissions/v2/permissions";

export const PermissionService = {
	async getAll({
		id
	}: DefaultGetParamsProps): Promise<GetObjectPermissionsDataResponse> {
		const response: AxiosResponse<GetObjectPermissionsDataResponse> =
			await apiNode.get<GetObjectPermissionsDataResponse>(
				`${URL}/${id}/all-object-permissions`
			);
		return response.data;
	},
	async getComputed({
		id
	}: DefaultGetParamsProps): Promise<GetComputedObjectPermissionsDataResponse> {
		const response: AxiosResponse<GetComputedObjectPermissionsDataResponse> =
			await apiNode.get<GetComputedObjectPermissionsDataResponse>(
				`${URL}/${id}/computed`
			);
		return response.data;
	},
	async getUserLevel({
		id
	}: DefaultGetParamsProps): Promise<GetUserPermissionLevelDataResponse> {
		const response: AxiosResponse<GetUserPermissionLevelDataResponse> =
			await apiNode.get<GetUserPermissionLevelDataResponse>(
				`${URL}/${id}/user-permission-level`
			);
		return response.data;
	},
	async selectSet({
		setId,
		id
	}: {
		setId: string | null;
		id: string;
	}) {
		return apiNode.patch(`${URL}/${id}/select-set`, { setId });
	}
};
